/**
 * RARCO LIFESTYLE - ADVANCED JAVASCRIPT
 * Modern animations, scroll effects, and interactive features
 */

(function() {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────────
     SCROLL REVEAL ANIMATIONS
     ───────────────────────────────────────────────────────────────────────── */
  class ScrollReveal {
    constructor() {
      this.elements = document.querySelectorAll('[data-animate]');
      this.observer = null;
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersection(entries),
          { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );
        this.elements.forEach(el => this.observer.observe(el));
      } else {
        // Fallback for older browsers
        this.elements.forEach(el => el.classList.add('is-visible'));
      }
    }

    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     SMOOTH SCROLL
     ───────────────────────────────────────────────────────────────────────── */
  class SmoothScroll {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          const targetId = anchor.getAttribute('href');
          if (targetId === '#') return;
          
          const target = document.querySelector(targetId);
          if (target) {
            e.preventDefault();
            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     BACK TO TOP BUTTON - DISABLED (Using footer back-to-top instead)
     ───────────────────────────────────────────────────────────────────────── */
  class BackToTop {
    constructor() {
      // Disabled - Premium footer has its own back-to-top button
      // this.button = null;
      // this.init();
    }

    init() {
      // Disabled
    }

    createButton() {
      // Disabled
    }

    bindEvents() {
      // Disabled
    }

    toggleVisibility() {
      // Disabled
    }

    scrollToTop() {
      // Disabled
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     FLOATING WHATSAPP BUTTON
     ───────────────────────────────────────────────────────────────────────── */
  class WhatsAppButton {
    constructor(phoneNumber = '', message = '') {
      this.phoneNumber = phoneNumber;
      this.message = message;
      if (this.phoneNumber) this.init();
    }

    init() {
      const button = document.createElement('a');
      button.className = 'floating-whatsapp';
      button.href = `https://wa.me/${this.phoneNumber}?text=${encodeURIComponent(this.message)}`;
      button.target = '_blank';
      button.rel = 'noopener noreferrer';
      button.setAttribute('aria-label', 'Chat on WhatsApp');
      button.innerHTML = `
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      `;
      document.body.appendChild(button);
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     MAGNETIC BUTTONS
     ───────────────────────────────────────────────────────────────────────── */
  class MagneticButtons {
    constructor() {
      this.buttons = document.querySelectorAll('.btn-magnetic');
      this.init();
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('mousemove', (e) => this.handleMove(e, button));
        button.addEventListener('mouseleave', (e) => this.handleLeave(e, button));
      });
    }

    handleMove(e, button) {
      const rect = button.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      button.style.transform = `translate(${x * 0.3}px, ${y * 0.3}px)`;
    }

    handleLeave(e, button) {
      button.style.transform = 'translate(0, 0)';
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     COUNTER ANIMATION
     ───────────────────────────────────────────────────────────────────────── */
  class CounterAnimation {
    constructor() {
      this.counters = document.querySelectorAll('[data-count]');
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.animate(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.5 });

        this.counters.forEach(counter => observer.observe(counter));
      }
    }

    animate(element) {
      const target = parseInt(element.dataset.count);
      const duration = 2000;
      const start = performance.now();
      
      const update = (currentTime) => {
        const elapsed = currentTime - start;
        const progress = Math.min(elapsed / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 3);
        
        element.textContent = Math.floor(target * easeProgress).toLocaleString();
        
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = target.toLocaleString() + '+';
        }
      };
      
      requestAnimationFrame(update);
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PARALLAX EFFECT
     ───────────────────────────────────────────────────────────────────────── */
  class ParallaxEffect {
    constructor() {
      this.elements = document.querySelectorAll('[data-parallax]');
      this.init();
    }

    init() {
      if (this.elements.length === 0) return;
      
      window.addEventListener('scroll', () => {
        requestAnimationFrame(() => this.update());
      });
    }

    update() {
      const scrolled = window.pageYOffset;
      
      this.elements.forEach(el => {
        const speed = parseFloat(el.dataset.parallaxSpeed) || 0.3;
        const media = el.querySelector('.premium-hero__media, .parallax-media');
        
        if (media) {
          const yPos = scrolled * speed;
          media.style.transform = `translateY(${yPos}px)`;
        }
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     WISHLIST FUNCTIONALITY
     ───────────────────────────────────────────────────────────────────────── */
  class Wishlist {
    constructor() {
      this.storageKey = 'rarco_wishlist';
      this.items = this.getItems();
      this.init();
    }

    init() {
      this.bindEvents();
      this.updateUI();
    }

    getItems() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch {
        return [];
      }
    }

    saveItems() {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
    }

    addItem(productId) {
      if (!this.items.includes(productId)) {
        this.items.push(productId);
        this.saveItems();
        this.updateUI();
        this.showNotification('Added to wishlist!');
      }
    }

    removeItem(productId) {
      this.items = this.items.filter(id => id !== productId);
      this.saveItems();
      this.updateUI();
      this.showNotification('Removed from wishlist');
    }

    toggleItem(productId) {
      if (this.items.includes(productId)) {
        this.removeItem(productId);
      } else {
        this.addItem(productId);
      }
    }

    bindEvents() {
      document.addEventListener('click', (e) => {
        const wishlistBtn = e.target.closest('[data-wishlist]');
        if (wishlistBtn) {
          e.preventDefault();
          const productId = wishlistBtn.dataset.wishlist;
          this.toggleItem(productId);
          wishlistBtn.classList.toggle('active');
        }
      });
    }

    updateUI() {
      document.querySelectorAll('[data-wishlist]').forEach(btn => {
        const productId = btn.dataset.wishlist;
        btn.classList.toggle('active', this.items.includes(productId));
      });
      
      const countEl = document.querySelector('[data-wishlist-count]');
      if (countEl) {
        countEl.textContent = this.items.length;
        countEl.style.display = this.items.length > 0 ? 'flex' : 'none';
      }
    }

    showNotification(message) {
      const notification = document.createElement('div');
      notification.className = 'wishlist-notification';
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        bottom: 100px;
        right: 30px;
        background: var(--rarco-primary, #1a1a2e);
        color: white;
        padding: 12px 24px;
        border-radius: 8px;
        z-index: 10000;
        animation: slideIn 0.3s ease;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
      `;
      document.body.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease forwards';
        setTimeout(() => notification.remove(), 300);
      }, 2000);
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     QUICK VIEW MODAL
     ───────────────────────────────────────────────────────────────────────── */
  class QuickView {
    constructor() {
      this.modal = null;
      this.init();
    }

    init() {
      this.createModal();
      this.bindEvents();
    }

    createModal() {
      this.modal = document.createElement('div');
      this.modal.className = 'quick-view-modal';
      this.modal.innerHTML = `
        <div class="quick-view-content">
          <button class="quick-view-close" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          <div class="quick-view-body"></div>
        </div>
      `;
      document.body.appendChild(this.modal);
    }

    bindEvents() {
      document.addEventListener('click', (e) => {
        const quickViewBtn = e.target.closest('[data-quick-view]');
        if (quickViewBtn) {
          e.preventDefault();
          const productUrl = quickViewBtn.dataset.quickView;
          this.open(productUrl);
        }
      });

      this.modal.querySelector('.quick-view-close').addEventListener('click', () => this.close());
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) this.close();
      });
      
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('active')) {
          this.close();
        }
      });
    }

    async open(productUrl) {
      const body = this.modal.querySelector('.quick-view-body');
      body.innerHTML = '<div class="quick-view-loading"><div class="preloader-spinner"></div></div>';
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      try {
        const response = await fetch(`${productUrl}?view=quick-view`);
        const html = await response.text();
        body.innerHTML = html;
      } catch (error) {
        body.innerHTML = '<p>Error loading product. Please try again.</p>';
      }
    }

    close() {
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     LAZY LOADING IMAGES
     ───────────────────────────────────────────────────────────────────────── */
  class LazyImages {
    constructor() {
      this.images = document.querySelectorAll('img[data-src]');
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadImage(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '50px' });

        this.images.forEach(img => observer.observe(img));
      } else {
        this.images.forEach(img => this.loadImage(img));
      }
    }

    loadImage(img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.classList.add('loaded');
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PRELOADER
     ───────────────────────────────────────────────────────────────────────── */
  class Preloader {
    constructor() {
      this.preloader = document.querySelector('.preloader');
      this.init();
    }

    init() {
      if (!this.preloader) return;
      
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.preloader.classList.add('hidden');
          setTimeout(() => this.preloader.remove(), 500);
        }, 500);
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     HEADER SCROLL EFFECT
     ───────────────────────────────────────────────────────────────────────── */
  class HeaderScroll {
    constructor() {
      this.header = document.querySelector('header, .header');
      this.lastScroll = 0;
      this.init();
    }

    init() {
      if (!this.header) return;
      
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > 100) {
          this.header.classList.add('header-scrolled');
        } else {
          this.header.classList.remove('header-scrolled');
        }
        
        this.lastScroll = currentScroll;
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     INITIALIZE ALL MODULES
     ───────────────────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    // Core functionality
    new ScrollReveal();
    new SmoothScroll();
    new BackToTop();
    new ParallaxEffect();
    new HeaderScroll();
    new Preloader();
    new LazyImages();
    
    // Interactive features
    new MagneticButtons();
    new CounterAnimation();
    new Wishlist();
    new QuickView();
    
    // Quick View button handler (for product cards with .quickview-btn)
    document.addEventListener('click', (e) => {
      const quickViewBtn = e.target.closest('.quickview-btn');
      if (quickViewBtn) {
        e.preventDefault();
        const productHandle = quickViewBtn.dataset.productHandle;
        if (productHandle && typeof openQuickView === 'function') {
          openQuickView(productHandle);
        }
      }
    });
    
    // WhatsApp - Update with actual phone number
    const whatsappNumber = window.rarcoSettings?.whatsappNumber || '';
    const whatsappMessage = window.rarcoSettings?.whatsappMessage || 'Hi! I have a query about your products.';
    if (whatsappNumber) {
      new WhatsAppButton(whatsappNumber, whatsappMessage);
    }
    
    console.log('🚀 Rarco Lifestyle - All modules initialized');
  });

  /* ─────────────────────────────────────────────────────────────────────────
     CSS ANIMATIONS (Injected)
     ───────────────────────────────────────────────────────────────────────── */
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100px); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100px); opacity: 0; }
    }
    
    .quick-view-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
    }
    
    .quick-view-close {
      position: absolute;
      top: 20px;
      right: 20px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 10;
      padding: 8px;
      border-radius: 50%;
      transition: background 0.3s ease;
    }
    
    .quick-view-close:hover {
      background: rgba(0,0,0,0.1);
    }
    
    .header-scrolled {
      background: rgba(255, 255, 255, 0.95) !important;
      backdrop-filter: blur(10px);
      box-shadow: 0 2px 20px rgba(0,0,0,0.1);
    }
    
    img.loaded {
      animation: fadeIn 0.3s ease;
    }
    
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `;
  document.head.appendChild(style);

})();
